import React, {useEffect, useState} from "react";
import {getStockValuationFxn} from "../actions";
import {Card, Table} from "../../../components/Elements/appUtils";

const OpdReport = () => {
    const [reportData, setReportData] = useState([]);
    const [totalValuation, setTotalValuation] = useState(0);
    const getReportFxn = async (params = {}) => {
        const {data, totalValue} = await getStockValuationFxn(params);
        setReportData(data || []);
        setTotalValuation(totalValue || 0)
    };

    // Initial load
    useEffect(() => {
        getReportFxn();
    }, []);


    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Product Name",
            dataIndex: "productName",
            key: "productName",
        },
        {
            title: "Product Code",
            dataIndex: "code",
            key: "code",
        },
        {
            title: "HSN",
            dataIndex: "hsnCode",
            key: "hsnCode",
        },

        {
            title: "Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (item) => {
                return item ? `Rs. ${item.toFixed(2)}` : null
            }
        },
        {
            title: "Batch",
            dataIndex: "records",
            key: "records",
            width: '30%',
            render: (record) => {
                return (
                    <>
                        <ul className={'ul-sm'}>
                            {record.map((item) => {
                                return (
                                    <li key={item._id}>
                                        <div>
                                            <span>{item.batchNo}</span>
                                            <span>{item.quantity} x Rs. {item.price} = <strong>Rs. {item.total.toFixed(2)}</strong></span>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </>
                )
            }
        },
    ];

    return (
        <Card title="Stock Valuation" actions={(
            <>
                Total Valuation : <strong>Rs. {totalValuation.toFixed(2)}</strong>
            </>
        )}>
            <div className="row ">
                <div className="col-md-12" key={reportData.length}>
                    <div>
                        <Table
                            dataSource={reportData}
                            columns={columns}
                            rowKey="_id"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default OpdReport;
